/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowTypeEnum } from './ShowTypeEnum';
import {
    ShowTypeEnumFromJSON,
    ShowTypeEnumFromJSONTyped,
    ShowTypeEnumToJSON,
    ShowTypeEnumToJSONTyped,
} from './ShowTypeEnum';
import type { Status02dEnum } from './Status02dEnum';
import {
    Status02dEnumFromJSON,
    Status02dEnumFromJSONTyped,
    Status02dEnumToJSON,
    Status02dEnumToJSONTyped,
} from './Status02dEnum';

/**
 * Serializer for creating/updating shows with stage and performer assignments.
 * @export
 * @interface PatchedShowCreateUpdate
 */
export interface PatchedShowCreateUpdate {
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    description?: string;
    /**
     * 
     * @type {ShowTypeEnum}
     * @memberof PatchedShowCreateUpdate
     */
    showType?: ShowTypeEnum;
    /**
     * 
     * @type {Status02dEnum}
     * @memberof PatchedShowCreateUpdate
     */
    status?: Status02dEnum;
    /**
     * Show date - null for tentative shows until confirmed
     * @type {Date}
     * @memberof PatchedShowCreateUpdate
     */
    showDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    doorsTime?: string | null;
    /**
     * Preferred show time - null for tentative shows
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    showTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    endTime?: string | null;
    /**
     * Actual attendance count
     * @type {number}
     * @memberof PatchedShowCreateUpdate
     */
    attendance?: number | null;
    /**
     * Total ticket sales
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    ticketRevenue?: string | null;
    /**
     * Bar/concessions revenue
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    barRevenue?: string | null;
    /**
     * Merchandise, parking, etc.
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    otherRevenue?: string | null;
    /**
     * Production, staffing, etc.
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    totalExpenses?: string | null;
    /**
     * Default performer deal type for this show.
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    performerDealType?: string | null;
    /**
     * Who the configured door deal percentage belongs to.
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    doorDealPercentageOwner?: string | null;
    /**
     * Configured split percentage for the selected owner (optional).
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    doorDealPercentage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedShowCreateUpdate
     */
    isSettled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PatchedShowCreateUpdate
     */
    settlementDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    settlementNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedShowCreateUpdate
     */
    notes?: string;
    /**
     * Team that created/manages this show
     * @type {number}
     * @memberof PatchedShowCreateUpdate
     */
    team?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedShowCreateUpdate
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedShowCreateUpdate
     */
    stages?: Array<string>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof PatchedShowCreateUpdate
     */
    performers?: Array<{ [key: string]: any; }>;
}



/**
 * Check if a given object implements the PatchedShowCreateUpdate interface.
 */
export function instanceOfPatchedShowCreateUpdate(value: object): value is PatchedShowCreateUpdate {
    return true;
}

export function PatchedShowCreateUpdateFromJSON(json: any): PatchedShowCreateUpdate {
    return PatchedShowCreateUpdateFromJSONTyped(json, false);
}

export function PatchedShowCreateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedShowCreateUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'showType': json['show_type'] == null ? undefined : ShowTypeEnumFromJSON(json['show_type']),
        'status': json['status'] == null ? undefined : Status02dEnumFromJSON(json['status']),
        'showDate': json['show_date'] == null ? undefined : (new Date(json['show_date'])),
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'ticketRevenue': json['ticket_revenue'] == null ? undefined : json['ticket_revenue'],
        'barRevenue': json['bar_revenue'] == null ? undefined : json['bar_revenue'],
        'otherRevenue': json['other_revenue'] == null ? undefined : json['other_revenue'],
        'totalExpenses': json['total_expenses'] == null ? undefined : json['total_expenses'],
        'performerDealType': json['performer_deal_type'] == null ? undefined : json['performer_deal_type'],
        'doorDealPercentageOwner': json['door_deal_percentage_owner'] == null ? undefined : json['door_deal_percentage_owner'],
        'doorDealPercentage': json['door_deal_percentage'] == null ? undefined : json['door_deal_percentage'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
        'settlementDate': json['settlement_date'] == null ? undefined : (new Date(json['settlement_date'])),
        'settlementNotes': json['settlement_notes'] == null ? undefined : json['settlement_notes'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'team': json['team'] == null ? undefined : json['team'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'stages': json['stages'] == null ? undefined : json['stages'],
        'performers': json['performers'] == null ? undefined : json['performers'],
    };
}

  export function PatchedShowCreateUpdateToJSON(json: any): PatchedShowCreateUpdate {
      return PatchedShowCreateUpdateToJSONTyped(json, false);
  }

  export function PatchedShowCreateUpdateToJSONTyped(value?: Omit<PatchedShowCreateUpdate, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'show_type': ShowTypeEnumToJSON(value['showType']),
        'status': Status02dEnumToJSON(value['status']),
        'show_date': value['showDate'] == null ? undefined : ((value['showDate'] as any).toISOString().substring(0,10)),
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'attendance': value['attendance'],
        'ticket_revenue': value['ticketRevenue'],
        'bar_revenue': value['barRevenue'],
        'other_revenue': value['otherRevenue'],
        'total_expenses': value['totalExpenses'],
        'performer_deal_type': value['performerDealType'],
        'door_deal_percentage_owner': value['doorDealPercentageOwner'],
        'door_deal_percentage': value['doorDealPercentage'],
        'is_settled': value['isSettled'],
        'settlement_date': value['settlementDate'] == null ? undefined : ((value['settlementDate'] as any).toISOString().substring(0,10)),
        'settlement_notes': value['settlementNotes'],
        'notes': value['notes'],
        'team': value['team'],
        'is_active': value['isActive'],
        'stages': value['stages'],
        'performers': value['performers'],
    };
}

